import { getPriceStatus } from '@helpers/utils/numbers/numbers';
import { priceChangeColors } from '@terminal/utils/common/utils';
import { formatPercentageNumber } from '@terminal/widgets/earnings/utils/utils';

import { PulseBigMover } from '../../pulse-types';

export const toPulseBigMoverRankedRows = (movers: PulseBigMover[]) =>
  movers.map(mover => ({
    ...mover,
    company: {
      entityTag: mover.entity.tag,
      name: mover.entity.name_short || mover.entity.name,
      ticker: mover.entity.ticker,
    },
  }));

export const renderPulseBigMoverChange = (mover: PulseBigMover) => (
  <span
    style={{
      color: priceChangeColors[getPriceStatus(mover.changePercent)],
    }}
  >
    {formatPercentageNumber({
      value: mover.changePercent,
      includePercentSign: false,
      addPlus: true,
    })}
  </span>
);
